import axios from "axios";
import { API_URL } from "@/config";

const store = {
  namespaced: true,

  actions: {
    async getManyOnlinePayments(_, criteria) {
      const res = await axios.get(`${API_URL}/payments/online`, { params: criteria });

      if (!res.data || typeof res.data.items !== "object") {
        throw new Error("Error occurred while processing your request.");
      }

      return res.data;
    },
  },
};

export default store;
